import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxFormComponent } from 'devextreme-angular';
import { ToastrService } from 'ngx-toastr';
import { AuthorizationService } from 'src/app/services/authorization.service';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrl: './change-password-modal.component.scss',
  standalone: false
})
export class ChangePasswordModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @ViewChild('form') form!: DxFormComponent;

  formData = {
    password: '',
    repeatPassword: ''
  };

  passwordVisible = false;
  repeatPasswordVisible = false;

  constructor(
    private toastrService: ToastrService,
    private authorizationService: AuthorizationService,
    private translateService: TranslateService
  ) {}

  togglePasswordVisibility = (e: any) => {
    this.passwordVisible = !this.passwordVisible;
    e.component.option('mode', this.passwordVisible ? 'text' : 'password');
  };

  toggleRepeatPasswordVisibility = (e: any) => {
    this.repeatPasswordVisible = !this.repeatPasswordVisible;
    e.component.option('mode', this.repeatPasswordVisible ? 'text' : 'password');
  };

  passwordComplexityCheck = (e: any) => {
    const value: string = e.value || '';
    const minLength = 10;
    const hasUpper = /[A-Z]/.test(value);
    const hasLower = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpecial = /[!@#$%^&*\-_+=?.,:;'()€]/.test(value);
    return value.length >= minLength && hasUpper && hasLower && hasNumber && hasSpecial;
  };

  repeatPasswordValidation = (e: any) => {
    return e.value === this.formData.password;
  };

  submit = () => {
    const isValid = this.form.instance.validate().isValid;
    if (!isValid) {
      this.toastrService.error(
        this.translateService.instant('USER-NAV.CHANGE-PASSWORD-MODAL.SUBMIT-ERROR')
      );
      return;
    }

    this.authorizationService
      .changePassword({
        password: this.formData.password
      })
      .subscribe(() => {
        this.formData = {
          password: '',
          repeatPassword: ''
        };
        this.closeModal();
      });
  };

  closeModal() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
